import { createFormState, hasLength } from 'redux-freeform';

const voidFormConfig = {
  notes: {
    defaultValue: '',
    validators: [hasLength(0, 250)], // optional field
  },
};

export const {
  reducer: voidFormReducer,
  mapStateToProps: voidFormMapStateToProps,
  mapDispatchToProps: voidFormMapDispatchToProps,
} = createFormState(voidFormConfig);
